import React from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';

const PermissionGate = ({ 
  children, 
  permission,
  requiredPermission, // Alias for permission (for consistency with ProtectedRoute)
  permissions, 
  requireAll = false,
  fallback = null,
  showError = false 
}) => {
  const { user, isAuthenticated } = useAdminAuth();

  if (!isAuthenticated) {
    return fallback;
  }

  const userPermissions = user?.permissions || [];
  let hasAccess = false;

  // Use requiredPermission if provided, otherwise use permission
  const checkPermission = requiredPermission || permission;

  if (checkPermission) {
    hasAccess = userPermissions.includes(checkPermission);
  } else if (permissions && Array.isArray(permissions)) {
    if (requireAll) {
      hasAccess = permissions.every(perm => userPermissions.includes(perm));
    } else {
      hasAccess = permissions.some(perm => userPermissions.includes(perm));
    }
  }

  if (!hasAccess) {
    if (showError) {
      return (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-yellow-800">
          <p className="font-semibold">Access Denied</p>
          <p className="text-sm">
            You don't have permission to view this content.
            {permission && ` Required: ${permission}`}
            {permissions && ` Required: ${permissions.join(' or ')}`}
          </p>
        </div>
      );
    }
    return fallback;
  }

  return <>{children}</>;
};

export default PermissionGate;

